/**
 * Ambient colour depth for the login screen.
 *
 * Three large, slowly drifting blurred orbs in the app's primary blues. Their
 * only job is to give the frosted form panel something worth blurring — on a
 * flat ground the glass reads as a plain translucent box. The product story is
 * told by <AuthGlobe /> on the other side of the split, so this layer stays
 * deliberately quiet.
 *
 * aria-hidden and pointer-events-none throughout. Under the OS reduced-motion
 * preference or the in-app `a11y-reduced-motion` toggle the drift stops (see
 * the reduced-motion rules in the stylesheet) and the orbs simply sit still.
 */
export function AuthBackdrop() {
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
      <span className="auth-glow auth-glow-1" />
      <span className="auth-glow auth-glow-2" />
      <span className="auth-glow auth-glow-3" />
    </div>
  );
}
